/*
 * @providesModule Withdrawal
 *
 */

import React from 'react';

import _ from 'lodash';
import AccountInfoModal from 'AccountInfoModal';
import AWSManager from 'AWSManager';
import {
  WITHDRAWAL_PAYPAL_EMAIL_CHANGE,
  WITHDRAWAL_METHOD_CHECK,
  WITHDRAWAL_METHOD_PAYPAL,
  WITHDRAWAL_PROCESSING_FEE_MODAL,
  WITHDRAWAL_NEXT,
  WITHDRAWAL_CONFIRM_WITHDRAWAL_MODAL,
  WITHDRAWAL_SUCCESS_MODAL,
  WITHDRAWAL_PAYPAL_WARNING,
} from 'AWSConstants';
import CancelWithdrawal from 'CancelWithdrawal';
import ClientPropertyConstants from 'ClientPropertyConstants';
import CurrencyController from 'CurrencyController';
import CurrentUserStore from 'CurrentUserStore';
import DataDogRUM from 'DataDogRUM';
import I18n, {CurrencyCode} from 'INTL';
import Label from 'Label';
import LoadingIndicator from 'LoadingIndicator';
import ModalNavigationController from 'ModalNavigationController';
import NavigationBar from 'NavigationBar';
import NavigationManager from 'NavigationManager';
import NetClient from 'NetClient';
import Optional from 'Optional';
import PushButton from 'PushButton';
import SegmentedControlTab from 'react-native-segmented-control-tab';
import Sizes from 'Sizes';
import SkillzImage from 'SkillzImage';
import SKZConstants from 'SKZConstants';
import SKZPersonalInfo from 'SKZPersonalInfo';
import styles from 'WithdrawalStyle';
import {TextField} from 'react-native-material-textfield';
import WithdrawalController from 'WithdrawalController';
import WithdrawalSuccessModal from 'WithdrawalSuccessModal';
import SkillzModule from 'SkillzModule';
import InterstitialsManager from 'InterstitialsManager';
import {Interstitials} from 'InterstitialConstants';
import SelectPaypalEmail from 'SelectPaypalEmail';
import {
  View,
  ScrollView,
  TouchableOpacity,
  NativeModules,
  KeyboardAvoidingView,
  Platform,
  Text,
  Linking,
} from 'react-native';
import SkillzRouter from 'SkillzRouter';
import {trackTelemetryEvent} from 'TrackTelemetryEvent';
import {TelemetryEventName} from 'TelemetryConstants';
import WithdrawalPlaythroughInfo from 'WithdrawalPlaythroughInfo';
import {PLAYTHROUGH_FAQ_URL} from '../../Withdrawal/BankWithdrawal/BankWithdrawalConstants';

const SKZAPIManager = NativeModules.SKZAPIManager;

const gameId = SkillzModule.App.GameId;

const WITHDRAWAL_ERRORS = {
  exceeds: 'exceeds',
  low: 'low',
  empty: 'empty',
};

const IOS_NAV_BAR_HEIGHT = Sizes.orientation({
  portrait: 44,
  landscape: Sizes.select({
    tablet: 44,
    phone: 32,
  }),
});

export const TEST_IDS = {
  withdraw_screen: 'withdraw_screen',
  primary_address: 'primary_address',
  account_balance: 'account_balance',
  account_balance_amount: 'account_balance_amount',
  bonus_cash: 'bonus_cash',
  bonus_cash_amount: 'bonus_cash_amount',
  available_withdrawal_balance: 'available_withdrawal_balance',
  available_withdrawal_balance_amount: 'available_withdrawal_balance_amount',
  withdrawal_amount_error: 'withdrawal_amount_error',
  processing_fee: 'processing_fee',
  processing_fee_amount: 'processing_fee_amount',
  total_withdraw: 'total_withdraw',
  total_withdraw_amount: 'total_withdraw_amount',
};

interface WithdrawalProps {}

interface WithdrawalState {
  userInfo: Object | null;
  personalInfo: SKZPersonalInfo | null;
  selectedTabIndex: number;
  withdrawalAmount: string;
  withdrawalAmountError: string | null;
  selectedPaypalEmail: string;
  addressEmptyError: boolean;
  hasReachedPayPalLimit: boolean;
}

export default class Withdrawal extends React.Component<WithdrawalProps, WithdrawalState> {
  /*
   * If making changes to personalInfo, do not mutate the state object directly.
   * Instead, create a new instance (new SKZPersonalInfo({...this.state.personalInfo})) and make changes to it.
   * This will cause a component update since we are using PureComponent (which uses ===).
   */
  _processingFee: number;
  FINAL_PROCESSING_FEE: number;
  _finalWithdrawalAmount: string;
  _processingFeeThreshold: number;
  currencyCode: CurrencyCode;
  _canSendWarningTrackingEvent: boolean;
  _currentPayPalWithdrawalTotal: number;
  _showStaticModalWithdrawalMethod: () => void;
  _showStaticModalBonusCash: () => void;
  _showStaticModalProcessingFee: () => void;
  STATIC_MODALS: {
    withdrawalMethod: {
      title: string;
      message: string;
      hideCancel: boolean;
      okButtonTitle: string;
    };
    bonusCash: {
      title: string;
      message: string;
      hideCancel: boolean;
      okButtonTitle: string;
    };
    processingFee: {
      title: string;
      message: string;
      hideCancel: boolean;
      okButtonTitle: string;
    };
  };
  BANNER_TEXT: string;
  _withdrawalAmountInput: any; // TextField from react-native-material-textfield doesn't have proper types
  _scrollView: ScrollView | null = null;
  _contentHeight: number = 0;
  _scrollViewHeight: number = 0;

  constructor(props: WithdrawalProps) {
    super(props);
    this.state = {
      userInfo: null,
      personalInfo: null,
      selectedTabIndex:
        ClientPropertyConstants.getPlayerWithdrawalMethod() == SKZConstants.PAYPAL ? 1 : 0,
      withdrawalAmount: '',
      withdrawalAmountError: null,
      selectedPaypalEmail: '',
      addressEmptyError: false,
      hasReachedPayPalLimit: false,
    };
    this._processingFee = CurrencyController.isUSD()
      ? SKZConstants.DEFAULT_PROCESSING_FEE
      : SKZConstants.DEFAULT_INR_PROCESSING_FEE;
    this.FINAL_PROCESSING_FEE = CurrencyController.isUSD()
      ? SKZConstants.DEFAULT_PROCESSING_FEE
      : SKZConstants.DEFAULT_INR_PROCESSING_FEE;
    this._finalWithdrawalAmount = this._formatToCurrency(0);
    this._processingFeeThreshold = CurrencyController.isUSD()
      ? SKZConstants.MINIMUM_WITHDRAWAL_WITHOUT_FEE
      : SKZConstants.MINIMUM_INR_WITHDRAWAL_WITHOUT_FEE;
    this.currencyCode = I18n.currentCurrency();
    this._canSendWarningTrackingEvent = true;
    this._currentPayPalWithdrawalTotal = 0;
    this._showStaticModalWithdrawalMethod = this._showStaticModal.bind(this, 'withdrawalMethod');
    this._showStaticModalBonusCash = this._showStaticModal.bind(this, 'bonusCash');
    this._showStaticModalProcessingFee = this._showStaticModal.bind(this, 'processingFee');

    this.STATIC_MODALS = {
      withdrawalMethod: {
        title: I18n.message('Withdrawal Method'),
        message: I18n.message(
          'Withdrawals will be refunded via the original method when possible.'
        ),
        hideCancel: true,
        okButtonTitle: I18n.message('OK'),
      },
      bonusCash: {
        title: I18n.message('Bonus Cash'),
        message: I18n.message(
          'Bonus cash cannot be withdrawn. All Bonus cash will be forfeited when you withdraw.'
        ),
        hideCancel: true,
        okButtonTitle: I18n.message('OK'),
      },
      processingFee: {
        title: I18n.message('Processing Fee'),
        message: I18n.formattedMessage(
          'Withdrawals under {0} are subject to a {1} processing fee.',
          this._formatToCurrency(this._processingFeeThreshold),
          this._formatToCurrency(this._processingFee)
        ),
        hideCancel: true,
        okButtonTitle: I18n.message('OK'),
      },
    };
    this.BANNER_TEXT = I18n.message(
      'You have exceeded your PayPal withdrawal limit. You may withdraw via Check.'
    );
  }

  componentDidMount() {
    this._getPageData();
    CurrentUserStore.addChangeListener(this.onUserDataChange);
    trackTelemetryEvent({
      event: TelemetryEventName.WITHDRAW_STANDARD_PAGE_LOAD,
      payload: {
        type: this._getWithdrawalTypeForTelemetry(),
      },
      includeUserWalletDetails: true,
    });
    if (Sizes.isLandscape() || Platform.OS == 'android') {
      SkillzModule.setEnabledKeyboardManager(true);
    } else {
      SkillzModule.setEnabledKeyboardManager(false);
    }
  }

  onUserDataChange = async () => {
    const personalInfo = await CurrentUserStore.getUserPersonalInfo();
    this.setState({personalInfo: new SKZPersonalInfo(personalInfo)});
  };

  componentWillUnmount() {
    CurrentUserStore.removeChangeListener(this.onUserDataChange);
    if (Sizes.isLandscape() || Platform.OS == 'android') {
      SkillzModule.setEnabledKeyboardManager(false);
    }
  }

  get baseWithdrawal(): number {
    return this.parseAmount(this.state.withdrawalAmount);
  }

  get withdrawalFee(): number {
    return this.baseWithdrawal < this._processingFeeThreshold ? this._processingFee : 0.0;
  }

  _getPageData() {
    const userPersonalInfoPromise = CurrentUserStore.fetchUserPersonalInfo(true);
    const userInfoPromise = CurrentUserStore.fetchUser(true);
    const withdrawalFeeDataPromise = NetClient.getURL(
      '/payment/v2/user-withdrawal-fees',
      {},
      SKZAPIManager.OnError.promptRetry
    );
    const paypalWithdrawTotalPromise = WithdrawalController.fetchPendingPayPalWithdrawals();

    LoadingIndicator.show();
    // TODO make api call for PayPal Withdraw Limit here as well
    Promise.all([
      withdrawalFeeDataPromise,
      userInfoPromise,
      userPersonalInfoPromise,
      paypalWithdrawTotalPromise,
    ])
      .then((values: Array<Object>) => {
        if (values && values.length > 0) {
          let hasReachedPayPalLimit = false;
          this._currentPayPalWithdrawalTotal =
            values.length >= 4 ? _.get(values[3], 'lifetime_withdrawal_amount', 0) : 0;
          const defaultProcessingFee = CurrencyController.isUSD()
            ? SKZConstants.DEFAULT_PROCESSING_FEE
            : SKZConstants.DEFAULT_INR_PROCESSING_FEE;
          this._processingFee = _.get(values[0], 'withdrawal_fee', defaultProcessingFee);
          this.FINAL_PROCESSING_FEE = _.get(values[0], 'withdrawal_fee', defaultProcessingFee);
          const minimumWithdrawalWithoutFee = CurrencyController.isUSD()
            ? SKZConstants.MINIMUM_WITHDRAWAL_WITHOUT_FEE
            : SKZConstants.MINIMUM_INR_WITHDRAWAL_WITHOUT_FEE;
          this._processingFeeThreshold = _.get(
            values[0],
            'withdrawal_fee_threshold',
            minimumWithdrawalWithoutFee
          );
          this.currencyCode = _.get(values[0], 'currency', I18n.currentCurrency());

          this.STATIC_MODALS['processingFee'].message = I18n.message(
            'Withdrawals under {0} are subject to a {1} processing fee.',
            this._formatToCurrency(this._processingFeeThreshold),
            this._formatToCurrency(this.FINAL_PROCESSING_FEE)
          );

          if (
            this._currentPayPalWithdrawalTotal >=
            ClientPropertyConstants.getPlayerWithdrawalMaxAmount()
          ) {
            hasReachedPayPalLimit = true;
          }
          const personalInfo = new SKZPersonalInfo(values[2]);
          this.setState(
            {
              userInfo: values[1],
              personalInfo,
              hasReachedPayPalLimit,
              selectedTabIndex: !this._isUSAddress(personalInfo) ? 1 : this.state.selectedTabIndex,
            },
            () => {
              LoadingIndicator.hide();
            }
          );
        }
      })
      .catch((error: unknown) => {
        LoadingIndicator.hide();
        console.debug(
          'Error when fetching User information and Withdrawal information on Withdrawal screen: ',
          error
        );
      });
  }

  _onBackPress = () => {
    // FIXME: This is a temporary fix to handle the web and mobile different navigation behavior to solve a bug on the SDK side.
    if (Platform.OS === 'web') {
      SkillzRouter.back();
    } else {
      NavigationManager.pop();
    }
  };

  _pushUpdateAddress = () => {
    trackTelemetryEvent({
      event: TelemetryEventName.WITHDRAW_STANDARD_PAGE_CTA_CLICK,
      payload: {
        cta: 'Add Address',
      },
      includeUserWalletDetails: true,
    });

    SkillzRouter.push(`/games/${gameId}/account/address`, {
      isBoxChecked: _.get(this.state, 'userInfo.email_opt_in'),
      personalInfoSource: this.state.personalInfo,
    });
  };

  _pushChangeEmail = () => {
    AWSManager.trackEvent(WITHDRAWAL_PAYPAL_EMAIL_CHANGE);
    const selectPaypalEmail = (
      <SelectPaypalEmail
        selected={_.get(this.state.userInfo, 'email')}
        onSaveEmail={this._onSavePayPalEmail}
        onBackPress={this._onBackPressSelectPayPalEmail}
        personalInfo={this.state.personalInfo}
      />
    );

    ModalNavigationController.showModal(selectPaypalEmail);
  };

  _popToRoot = () => {
    this._hideModal(() => InterstitialsManager.sendTrigger(Interstitials.POST_WITHDRAWAL));
    SkillzRouter.backToRoot();
  };

  _onBackPressSelectPayPalEmail = (email: string, personalInfo: SKZPersonalInfo) => {
    const shouldForceAPI = !personalInfo.hasVerifiedAllEmails();
    this._onSavePayPalEmail(email, personalInfo, shouldForceAPI);
  };

  _onSavePayPalEmail = (
    email: string,
    personalInfo: SKZPersonalInfo,
    forceUpdateAPI: boolean = false
  ) => {
    ModalNavigationController.hideModal();
    if (email) {
      this.setState(
        {
          userInfo: {...this.state.userInfo, email},
          personalInfo: personalInfo,
          selectedPaypalEmail: email,
        },
        () => {
          if (forceUpdateAPI) {
            // This will force the withdraw page to grab the new user personal if the user happened to verify any emails while on the
            // select paypal email screen
            CurrentUserStore.fetchUserPersonalInfo(false)
              .then((personalInfoNew: Object) => {
                const info = new SKZPersonalInfo(personalInfoNew);
                this.setState({
                  personalInfo: info,
                });
              })
              .catch((error: unknown) => {
                console.debug('Error fetching user personal info on Withdraw controller: ', error);
              });
          }
        }
      );
    }
  };

  _onAddressUpdate = (newPersonalInfo: Object, newUserInfo: Object) => {
    const personalInfo = new SKZPersonalInfo(newPersonalInfo);
    this.setState({
      personalInfo,
      userInfo: newUserInfo,
      selectedTabIndex: !this._isUSAddress(personalInfo) ? 1 : this.state.selectedTabIndex,
    });
    if (this._hasAddress() && this.state.addressEmptyError) {
      this.setState({
        addressEmptyError: false,
      });
    }
    NavigationManager.pop();
  };

  _onAddressCancel = () => {
    this.setState({addressEmptyError: !this._hasAddress()});
  };

  _onTabPress = (tabIndex: number) => {
    const event = tabIndex == 0 ? WITHDRAWAL_METHOD_CHECK : WITHDRAWAL_METHOD_PAYPAL;
    AWSManager.trackEvent(event);
    this.setState({selectedTabIndex: tabIndex});
  };

  _hideModal = (completion?: () => void) => {
    ModalNavigationController.hideModal(completion);
  };

  _hasAddress(): boolean {
    return Boolean(this.state.personalInfo && this.state.personalInfo.hasAddress('SHIPPING'));
  }

  _isUSAddress(personalInfo?: SKZPersonalInfo): boolean {
    const country =
      _.get(personalInfo || this.state.personalInfo, 'shipping_address.country') || null;
    if (!country || country == 'US') {
      return true;
    }

    return false;
  }

  _getWithdrawalTypeForTelemetry(): 'paypal' | 'check' {
    // If personalInfo is available, check address country
    if (this.state.personalInfo) {
      const isUS = this._isUSAddress();

      // If address is not US, always PayPal
      if (!isUS) {
        return 'paypal';
      }

      // If US address and PayPal is not enabled, always Check
      if (!ClientPropertyConstants.getPlayerWithdrawalPayPalEnabled()) {
        return 'check';
      }

      // If US address and PayPal is enabled, use selectedTabIndex
      // (0 = Check, 1 = PayPal)
      return this.state.selectedTabIndex === 1 ? 'paypal' : 'check';
    }

    // Fallback: if personalInfo not loaded yet, use the initial method preference
    // This matches the logic in constructor where selectedTabIndex is initialized
    return ClientPropertyConstants.getPlayerWithdrawalMethod() == SKZConstants.PAYPAL
      ? 'paypal'
      : 'check';
  }

  _isValidInput(value: string): boolean {
    return !isNaN(this.parseAmount(value));
  }

  _isBlockedByPayPalLimit(): boolean {
    if (this.state.selectedTabIndex == 0 || !this._isUSAddress()) {
      return false;
    }

    return this.state.hasReachedPayPalLimit;
  }

  _canWithdraw(): boolean {
    const availableToWithdraw = this._getAvailableToWithdraw();
    const withdrawalAsNumber = this._getWithdrawalAsNumber();

    return Boolean(
      this.state.withdrawalAmount &&
        withdrawalAsNumber <= availableToWithdraw &&
        this.baseWithdrawal >= this.FINAL_PROCESSING_FEE &&
        (this._hasAddress() || !CurrencyController.isUSD()) &&
        !this._isBlockedByPayPalLimit()
    );
  }

  _getErrorText(): string {
    switch (this.state.withdrawalAmountError) {
      case WITHDRAWAL_ERRORS.empty:
        return I18n.message("This can't be blank");
      case WITHDRAWAL_ERRORS.exceeds:
        return I18n.message('Cannot exceed the Available for Withdrawal amount');
      case WITHDRAWAL_ERRORS.low:
        return I18n.message('Cannot be less than the processing fee');
      default:
        return '';
    }
  }

  _showStaticModal = (modalKey: string) => {
    if (modalKey == 'processingFee') {
      AWSManager.trackEvent(WITHDRAWAL_PROCESSING_FEE_MODAL);
    }
    trackTelemetryEvent({
      event: TelemetryEventName.WITHDRAW_STANDARD_PAGE_CTA_CLICK,
      payload: {
        cta: modalKey,
      },
      includeUserWalletDetails: true,
    });

    const infoModal = (
      <AccountInfoModal
        titleText={this.STATIC_MODALS[modalKey as keyof typeof this.STATIC_MODALS].title}
        bodyText={this.STATIC_MODALS[modalKey as keyof typeof this.STATIC_MODALS].message}
        hideCancelButton={
          this.STATIC_MODALS[modalKey as keyof typeof this.STATIC_MODALS].hideCancel
        }
        okButtonTitle={
          this.STATIC_MODALS[modalKey as keyof typeof this.STATIC_MODALS].okButtonTitle
        }
        onDone={this._hideModal}
      />
    );

    const modalDisplayProps = {
      animationType: 'fade' as const,
      transparent: true,
    };

    ModalNavigationController.showModal(infoModal, modalDisplayProps);
  };

  _onWithdrawalAmountChange = (amount: string) => {
    if (this.parseAmount(this.state.withdrawalAmount) == Number(this.parseAmount(amount))) {
      return;
    }

    if (this.state.withdrawalAmountError) {
      this.setState({withdrawalAmountError: null});
    }
    if (this.parseAmount(amount) >= this._processingFeeThreshold) {
      this._processingFee = 0;
    } else {
      this._processingFee = this.FINAL_PROCESSING_FEE;
    }

    this.setState({withdrawalAmount: amount});
    this._setFinalWithdrawalAmount(amount);
  };

  _onInputFocus = () => {
    if (Sizes.isPortrait()) {
      this._scrollToBottom();
    }

    setTimeout(() => {
      if (!this._hasAddress() && CurrencyController.isUSD()) {
        this.setState({addressEmptyError: true});
      }
    }, 100);
  };

  _onInputBlur = () => {
    if (this.state.withdrawalAmount && this._isValidInput(this.state.withdrawalAmount)) {
      const withdrawalAmountTemp = this._formatToCurrency(
        Number(this.parseAmount(this.state.withdrawalAmount))
      );
      this.setState({
        withdrawalAmount: this.parseAmount(withdrawalAmountTemp)
          .toString()
          .replace(/[^0-9.-]+/g, ''),
      });
    } else {
      this.setState(
        {
          withdrawalAmount: '',
          withdrawalAmountError: WITHDRAWAL_ERRORS.empty,
        },
        () => {
          this._withdrawalAmountInput.clear();
        }
      );
    }
  };

  parseAmount = (stringValue: string): number => {
    stringValue = stringValue.trim();
    let result = stringValue.replace(/[^0-9]/g, '');
    if (/[,\.]\d{1}$/.test(stringValue)) {
      result = result.replace(/(\d{1})$/, '.$1');
    } else if (/[,\.]\d{2}$/.test(stringValue)) {
      result = result.replace(/(\d{2})$/, '.$1');
    }
    result.replace(/,/g, '');
    return parseFloat(result);
  };

  _setFinalWithdrawalAmount = (amount: string) => {
    let amountAsNumber = this.parseAmount(amount);

    if (!amount || !this._isValidInput(amount)) {
      this._finalWithdrawalAmount = this._formatToCurrency(0);
      return;
    } else if (amountAsNumber < this._processingFeeThreshold) {
      amountAsNumber = amountAsNumber + this._processingFee;
    }

    this._updateHasReachedPayPalLimit(amountAsNumber);
    this._finalWithdrawalAmount = this._formatToCurrency(amountAsNumber);
  };

  _parseFinalWithdrawal(): number {
    let value = this.parseAmount(this._finalWithdrawalAmount).toString();
    // checks if money is formated like 4,50 instead of 4.50 and fixes it
    const distanceFromEnd =
      this._finalWithdrawalAmount.indexOf('$') - this._finalWithdrawalAmount.indexOf(',');
    const distForCentsDivider = 4;
    if (distanceFromEnd == distForCentsDivider) {
      value = value.substring(0, value.length - 2) + '.' + value.substring(value.length - 2);
    }
    return Number(value.replace(/[^0-9.-]+/g, ''));
  }

  _parseFinalWithdrawalNonUSD(): number {
    const value = this.parseAmount(this._finalWithdrawalAmount).toString();
    return Number(value.replace(/[^0-9.-]+/g, '')) - this._processingFee;
  }

  _updateHasReachedPayPalLimit(withdrawalAmount: number) {
    const hasExceeded =
      withdrawalAmount + this._currentPayPalWithdrawalTotal >
      ClientPropertyConstants.getPlayerWithdrawalMaxAmount();

    if (this.state.hasReachedPayPalLimit != hasExceeded) {
      this.setState({hasReachedPayPalLimit: hasExceeded}, () => {
        if (this.state.selectedTabIndex == 1 && Sizes.isPortrait()) {
          this._scrollToBottom();
        }
      });
    }
  }

  _formatToCurrency(amount: number): string {
    return I18n.getCurrencyString(amount, '$', false, false);
  }

  _getAvailableToWithdraw(): number {
    const playthroughEnabled = ClientPropertyConstants.getPlaythroughEnabled();
    if (playthroughEnabled) {
      return parseFloat((_.get(this.state.userInfo, 'withdrawable_balance', 0) || 0).toFixed(2));
    } else {
      return parseFloat(
        (
          (_.get(this.state.userInfo, 'cash_balance', 0) || 0) -
          (_.get(this.state.userInfo, 'bonus_balance', 0) || 0)
        ).toFixed(2)
      );
    }
  }

  _getWithdrawalAsNumber(): number {
    return parseFloat((this.baseWithdrawal + this.withdrawalFee).toFixed(2));
  }

  handleUpdatedData = () => {
    const availableToWithdraw = this._getAvailableToWithdraw();
    const withdrawalAsNumber = this._getWithdrawalAsNumber();
    let withdrawalEmpty = false;

    if (this._canWithdraw()) {
      this._showConfirmModal();
      return;
    }

    if (!this.state.withdrawalAmount) {
      this.setState({withdrawalAmountError: WITHDRAWAL_ERRORS.empty});
      withdrawalEmpty = true;
    } else if (withdrawalAsNumber > availableToWithdraw) {
      this.setState({withdrawalAmountError: WITHDRAWAL_ERRORS.exceeds});
    } else if (this.baseWithdrawal < this.FINAL_PROCESSING_FEE) {
      this.setState({withdrawalAmountError: WITHDRAWAL_ERRORS.low});
    }

    if (!this._hasAddress() && CurrencyController.isUSD()) {
      this.setState({addressEmptyError: true});
    }

    if ((!this._hasAddress() && CurrencyController.isUSD()) || withdrawalEmpty) {
      this._showErrorModal(withdrawalEmpty);
    }
  };

  _isWithdrawalAmountValid(): boolean {
    const baseAmount = this.baseWithdrawal; // number
    const fee = this.withdrawalFee; // number
    const total = Number((baseAmount + fee).toFixed(2));

    const available = this._getAvailableToWithdraw();

    return total > 0 && total <= available;
  }

  _onNextPress = () => {
    const bonusBalance = _.get(this.state.userInfo, 'bonus_balance', 0) || 0;
    trackTelemetryEvent({
      event: TelemetryEventName.WITHDRAW_START_WITHDRAW_CLICK,
      payload: {
        withdraw_method: 'Standard',
        withdraw_amount: this.state.withdrawalAmount,
        fee_charged: this._processingFee,
        bc_forfeit: bonusBalance,
      },
      includeUserWalletDetails: true,
    });
    const {selectedPaypalEmail} = this.state;
    AWSManager.trackEvent(WITHDRAWAL_NEXT);

    const userPersonalInfoPromise = CurrentUserStore.fetchUserPersonalInfo(false);
    const userInfoPromise = CurrentUserStore.fetchUser(false);

    Promise.all([userInfoPromise, userPersonalInfoPromise]).then((values: Array<Object>) => {
      this.setState(
        {
          userInfo: selectedPaypalEmail ? {...values[0], email: selectedPaypalEmail} : values[0],
          personalInfo: new SKZPersonalInfo(values[1]),
        },
        () => {
          if (!this._isWithdrawalAmountValid()) {
            this.setState({withdrawalAmountError: WITHDRAWAL_ERRORS.exceeds});
            return;
          }

          this.handleUpdatedData();
        }
      );
    });
  };
  _onConfirmPress = () => {
    trackTelemetryEvent({
      event: TelemetryEventName.WITHDRAW_CONFIRM_POPUP_CTA_CLICK,
      includeUserWalletDetails: true,
      payload: {
        cta: 'confirm',
      },
    });
    this._hideModal();

    if (this.state.selectedTabIndex == 1) {
      this._withdraw(SKZConstants.PAYPAL, this.state.userInfo.email);
    } else {
      this._withdraw('Check');
    }
  };

  _withdraw(method: string, param: string) {
    LoadingIndicator.show();
    if (CurrencyController.isUSD()) {
      WithdrawalController.withdraw(method, this._parseFinalWithdrawal(), param)
        .then((response: Object) => {
          if (_.get(response, '[0].type')) {
            LoadingIndicator.hide();
            this._showSuccessModal();
          }
          LoadingIndicator.hide();
        })
        .catch((error: unknown) => {
          LoadingIndicator.hide();
          this._showServerErrorModal(error);
        });
    } else {
      const cashBalance = _.get(this.state.userInfo, 'cash_balance', 0) || 0;
      const bonusBalance = _.get(this.state.userInfo, 'bonus_balance', 0) || 0;
      WithdrawalController.nonUSDWithdraw(
        cashBalance,
        bonusBalance,
        this._parseFinalWithdrawalNonUSD(),
        this.state.userInfo.email
      )
        .then(() => {
          LoadingIndicator.hide();
          this._showSuccessModal();
        })
        .catch((error: unknown) => {
          LoadingIndicator.hide();
          this._showServerErrorModal(error);
        });
    }
  }

  _showConfirmModal() {
    AWSManager.trackEvent(WITHDRAWAL_CONFIRM_WITHDRAWAL_MODAL);
    const bonusCash = this._formatToCurrency(_.get(this.state.userInfo, 'bonus_balance', 0) || 0);
    let bodyContents = null;

    if (_.get(this.state.userInfo, 'bonus_balance', 0) == 0) {
      bodyContents = (
        <View style={styles.confirmModalContent}>
          <Label style={styles.bodyText}>
            {I18n.message('Withdraw {0}?', this._finalWithdrawalAmount)}
          </Label>
        </View>
      );
    } else {
      bodyContents = (
        <View style={styles.confirmModalContent}>
          <Label style={styles.bodyText}>
            {I18n.message('Withdraw {0}?', this._finalWithdrawalAmount)}
          </Label>
          <Label style={[styles.confirmModalBonusText, styles.bodyText]} numberOfLines={2}>
            {I18n.message(
              'Your Bonus Cash balance of {0} will be forfeited if you proceed with this withdrawal.',
              bonusCash
            )}
          </Label>
        </View>
      );
    }

    const confirmModal = (
      <AccountInfoModal
        titleText={I18n.message('Confirm Withdrawal')}
        bodyContents={bodyContents}
        okButtonTitle={I18n.message('Withdraw')}
        onDone={this._onConfirmPress}
        onCancel={() => {
          trackTelemetryEvent({
            event: TelemetryEventName.WITHDRAW_CONFIRM_POPUP_CTA_CLICK,
            includeUserWalletDetails: true,
            payload: {
              cta: 'cancel',
            },
          });
          this._hideModal();
        }}
      />
    );

    const modalDisplayProps = {
      animationType: 'fade' as const,
      transparent: true,
    };

    ModalNavigationController.showModal(confirmModal, modalDisplayProps);
  }

  _showSuccessModal(): React.ReactNode | void {
    if (Platform.OS === 'web') {
      return SkillzRouter.push(`/games/${gameId}/home?withdrawSuccess=true`);
    }

    AWSManager.trackEvent(WITHDRAWAL_SUCCESS_MODAL);
    trackTelemetryEvent({
      event: TelemetryEventName.WITHDRAW_SUCCESS_SHOWN,
      includeUserWalletDetails: true,
    });
    const successModal = (
      <WithdrawalSuccessModal
        title={I18n.message('Success!')}
        bodyText={I18n.message(
          'Your withdrawal request has been completed. You will receive an email confirming the transaction.'
        )}
        numberOfLines={4}
        onDone={this._popToRoot}
      />
    );

    const modalDisplayProps = {
      animationType: 'fade' as const,
      transparent: true,
    };

    ModalNavigationController.showModal(successModal, modalDisplayProps);
  }

  _showErrorModal(withdrawalEmpty: boolean) {
    const addressError =
      !this._hasAddress() && CurrencyController.isUSD() ? (
        <Label style={styles.errorBodyText}>{I18n.message('Address')}</Label>
      ) : null;
    const withdrawalAmountError = withdrawalEmpty ? (
      <Label style={styles.errorBodyText}>{I18n.message('Withdrawal Amount')}</Label>
    ) : null;

    const bodyContents = (
      <View style={styles.errorModalContentContainer}>
        {addressError}
        {withdrawalAmountError}
      </View>
    );

    const errorModal = (
      <AccountInfoModal
        titleText={I18n.message('Please complete the following fields')}
        bodyContents={bodyContents}
        hideCancelButton
        onDone={this._hideModal}
      />
    );

    const modalDisplayProps = {
      animationType: 'fade' as const,
      transparent: true,
    };

    ModalNavigationController.showModal(errorModal, modalDisplayProps);
  }

  _showServerErrorModal(error: any) {
    if (error) {
      console.debug('Error in method _withdraw inside Withdrawal screen', error);
    }

    const message =
      error?.message ?? I18n.message("Uh oh! Doesn't look like that worked. Please try again");
    const errorModal = (
      <AccountInfoModal
        titleText={I18n.message('Error')}
        bodyText={message}
        hideCancelButton
        onDone={this._hideModal}
      />
    );

    const modalDisplayProps = {
      animationType: 'fade' as const,
      transparent: true,
    };

    ModalNavigationController.showModal(errorModal, modalDisplayProps);
  }

  _scrollToBottom = () => {
    const scrollHeight = this._contentHeight - this._scrollViewHeight;
    if (scrollHeight > 0) {
      this._scrollView?.scrollTo({x: 0, y: scrollHeight, animated: true});
    }
  };

  _onContentSizeChange = (w: number, h: number) => {
    this._contentHeight = h;
  };

  _onContentLayout = (event: Object) => {
    this._scrollViewHeight = event.nativeEvent.layout.height;
  };

  _renderNavigationBar(): React.ReactNode {
    const style = Sizes.isPortrait() ? styles.navbar : {};

    return (
      <View style={style}>
        <NavigationBar
          hasBackButton
          onBackButtonPress={this._onBackPress}
          title={I18n.message('Withdraw')}
        />
      </View>
    );
  }

  _renderPayPalLimitBanner(): React.ReactNode | null {
    if (
      this.state.selectedTabIndex != 1 ||
      !this.state.hasReachedPayPalLimit ||
      !this._isUSAddress()
    ) {
      return null;
    }

    if (this._canSendWarningTrackingEvent) {
      this._canSendWarningTrackingEvent = false;
      AWSManager.trackEvent(WITHDRAWAL_PAYPAL_WARNING);
    }

    return (
      <View style={styles.bannerContainer}>
        <Label style={styles.bannerText} numberOfLines={2}>
          {this.BANNER_TEXT}
        </Label>
      </View>
    );
  }

  _renderMethodSection(): React.ReactNode {
    return (
      <View style={styles.section}>
        <Label style={[styles.lightText, styles.sectionTitle, styles.flexOne]}>
          {I18n.message('Withdrawal Method')}
        </Label>
        <TouchableOpacity
          style={styles.infoButton}
          onPress={this._showStaticModalWithdrawalMethod}
          accessible={true}
          accessibilityLabel={'withdrawal_method_info'}
          hitSlop={{top: 10, left: 10, bottom: 10, right: 10}}
        >
          <SkillzImage
            source={'ic_info_skz.png'}
            color={'rgb(74, 144, 226)'}
            style={styles.infoIcon}
          />
        </TouchableOpacity>
        {this._renderMethodSectionPaymentTypes()}
      </View>
    );
  }

  _renderMethodSectionPaymentTypes(): React.ReactNode {
    if (!this._isUSAddress()) {
      AWSManager.trackEvent('WITHDRAWAL_METHOD_PAYPAL');
      return <Label style={styles.sectionText}>{I18n.message('PayPal')}</Label>;
    } else if (ClientPropertyConstants.getPlayerWithdrawalPayPalEnabled()) {
      return (
        <SegmentedControlTab
          selectedIndex={this.state.selectedTabIndex}
          values={[I18n.message('Check'), I18n.message('PayPal')]}
          tabsContainerStyle={styles.tabsContainer}
          tabStyle={styles.tab}
          activeTabStyle={styles.activeTab}
          tabTextStyle={styles.tabText}
          activeTabTextStyle={styles.activeTabText}
          allowFontScaling={false}
          borderRadius={2}
          onTabPress={this._onTabPress}
        />
      );
    } else {
      return <Label style={styles.sectionText}>{I18n.message('Check')}</Label>;
    }
  }

  _renderPaypalEmailSection(): React.ReactNode | null {
    if (this.state.selectedTabIndex != 1) {
      return null;
    }

    return (
      <View style={styles.section}>
        <View style={styles.flexOne}>
          <Label style={[styles.lightText, styles.sectionTitle]}>
            {I18n.message('PayPal Email')}
          </Label>
          <Label style={styles.sectionText}>{_.get(this.state.userInfo, 'email', '') || ''}</Label>
        </View>
        <PushButton
          style={[styles.optionButton, {borderColor: 'rgb(74, 144, 226)'}]}
          onPress={this._pushChangeEmail}
          colors={['#FFF']}
          title={I18n.message('Change')}
          textStyle={styles.optionButtonText}
          cornerRadius={2}
          accessibilityLabel={'change_paypal_email'}
        />
      </View>
    );
  }

  _renderAddressSection(): React.ReactNode {
    const title = this._hasAddress() ? I18n.message('Edit') : I18n.message('Add');
    const buttonBorderColor = this.state.addressEmptyError
      ? 'rgb(188, 33, 49)'
      : 'rgb(74, 144, 226)';
    const accessibilityLabel = `${title}_primary_address`;

    return (
      <View style={styles.section}>
        <View style={styles.flexOne} testID={TEST_IDS.primary_address}>
          <Label style={[styles.lightText, styles.sectionTitle]}>
            {I18n.message('Primary Address')}
          </Label>
          {this._renderAddressContent()}
        </View>
        <View style={styles.verticalSection}>
          <PushButton
            style={[styles.optionButton, {borderColor: buttonBorderColor}]}
            onPress={this._pushUpdateAddress}
            colors={['#FFF']}
            title={title}
            textStyle={styles.optionButtonText}
            cornerRadius={2}
            accessibilityLabel={accessibilityLabel}
          />
          {this._renderAddressError()}
        </View>
      </View>
    );
  }

  _renderAddressContent(): React.ReactNode | null {
    if (this._hasAddress()) {
      return (
        <View>
          <Label style={styles.sectionText}>
            {`${_.get(this.state.personalInfo, 'shipping_address.first_name') || ''} ${_.get(this.state.personalInfo, 'shipping_address.last_name') || ''}`}
          </Label>
          <Label style={styles.sectionText}>
            {_.get(this.state.personalInfo, 'shipping_address.address_line1') || ''}
          </Label>
          <Label style={styles.sectionText}>
            {`${_.get(this.state.personalInfo, 'shipping_address.city') || ''}, ${_.get(this.state.personalInfo, 'shipping_address.state') || ''}`}
          </Label>
          <Label style={styles.sectionText}>
            {_.get(this.state.personalInfo, 'shipping_address.zip') || ''}
          </Label>
        </View>
      );
    } else {
      return <Label style={styles.largeLightText}>{I18n.message('Address Not Available')}</Label>;
    }
  }

  _renderAddressError(): React.ReactNode | null {
    if (!this.state.addressEmptyError) {
      return null;
    }

    return <Label style={styles.addressError}>{I18n.message('Add an address')}</Label>;
  }

  _renderWithdrawalDetails(): React.ReactNode {
    return (
      <View>
        <Label style={styles.withdrawalDetailsTitle}>{I18n.message('Withdrawal Details')}</Label>
        <Optional test={this.state.selectedTabIndex == 1 && this._isUSAddress()}>
          <Label style={styles.withdrawalDetailsMessage}>
            {I18n.message(
              'You may withdraw up to {0} using PayPal',
              I18n.getCurrencyString(
                ClientPropertyConstants.getPlayerWithdrawalMaxAmount(),
                '$',
                true,
                false
              )
            )}
          </Label>
        </Optional>
        {this._renderDetailsTop()}
        {this._renderDetailsBottom()}
      </View>
    );
  }

  _renderDetailsTop(): React.ReactNode {
    const cashBalance = _.get(this.state.userInfo, 'cash_balance', 0) || 0;
    const bonusBalance = _.get(this.state.userInfo, 'bonus_balance', 0) || 0;
    const withdrawableBalance = this._getAvailableToWithdraw() || 0;

    return (
      <View style={styles.detailsSection}>
        <View style={styles.detailRow}>
          <Label style={[styles.lightText, styles.flexOne]} testID={TEST_IDS.account_balance}>
            {I18n.message('Account Balance')}
          </Label>
          <Label style={styles.sectionText} testID={TEST_IDS.account_balance_amount}>
            {this._formatToCurrency(cashBalance)}
          </Label>
        </View>
        <View style={styles.detailRow}>
          <Label style={[styles.lightText, styles.flexOne]} testID={TEST_IDS.bonus_cash}>
            {I18n.message('Bonus Cash')}
          </Label>
          <TouchableOpacity
            style={styles.infoButton}
            onPress={this._showStaticModalBonusCash}
            accessible={true}
            accessibilityLabel={'bonus_cash_info'}
            hitSlop={{top: 10, left: 10, bottom: 10, right: 10}}
          >
            <SkillzImage
              source={'ic_info_skz.png'}
              color={'rgb(74, 144, 226)'}
              style={styles.infoIcon}
            />
          </TouchableOpacity>
          <Label style={styles.sectionText} testID={TEST_IDS.bonus_cash_amount}>
            {this._formatToCurrency(bonusBalance)}
          </Label>
        </View>
        <View style={styles.detailRow}>
          <Label
            style={[styles.lightText, styles.flexOne]}
            testID={TEST_IDS.available_withdrawal_balance}
          >
            {I18n.message('Available for Withdrawal')}
          </Label>
          <Label style={styles.sectionText} testID={TEST_IDS.available_withdrawal_balance_amount}>
            {this._formatToCurrency(withdrawableBalance)}
          </Label>
        </View>
        <View style={styles.detailRow}>
          <WithdrawalPlaythroughInfo
            canWithdraw={withdrawableBalance > 0}
          />
        </View>
      </View>
    );
  }

  _renderDetailsBottom(): React.ReactNode {
    return (
      <View style={styles.detailsSectionBottom}>
        {this._renderWithdrawalInput()}
        {this._renderProcessingFee()}
        <View style={styles.detailRow}>
          <Label style={[styles.lightText, styles.flexOne]} testID={TEST_IDS.total_withdraw}>
            {I18n.message('Total Withdraw Amount')}
          </Label>
          <Label style={styles.withdrawAmountText} testID={TEST_IDS.total_withdraw_amount}>
            {this._finalWithdrawalAmount}
          </Label>
        </View>
      </View>
    );
  }

  _renderFAQSupportSection(): React.ReactNode {
    return (
      <View style={styles.faqSupportSection}>
        <View style={[styles.detailRow, {marginBottom: 0, alignItems: 'flex-start'}]}>
          <Text style={[styles.faqSupportText, {marginRight: 8}]}>{'\u2022'}</Text>
          <View style={{flexDirection: 'row', flexWrap: 'nowrap', flex: 1}}>
            <Label style={styles.faqSupportText}>{I18n.message('Need more info? Check out the ')}</Label>
            <Text
              style={styles.faqSupportLinkText}
              onPress={() => Linking.openURL(PLAYTHROUGH_FAQ_URL)}
            >
              {I18n.message('FAQ')}
            </Text>
            <Label style={styles.faqSupportText}>{I18n.message(' or contact Support.')}</Label>
          </View>
        </View>
      </View>
    );
  }

  _renderWithdrawalInput(): React.ReactNode {
    const error = this._getErrorText();
    const accessibilityLabel =
      _.get(this.state.withdrawalAmount, 'length', 0) > 0
        ? 'withdrawal_amount_field_' + this.state.withdrawalAmount
        : 'withdrawal_amount_field';
    const prefixFontSize = Platform.OS === 'ios' ? 15 : 16.5;
    return (
      <TextField
        ref={(ref: unknown) => {
          this._withdrawalAmountInput = ref;
        }}
        style={styles.sectionText}
        testID={TEST_IDS.withdrawal_amount_error}
        inputContainerPadding={4}
        keyboardType={'numeric'}
        returnKeyType={'done'}
        label={I18n.message('Enter Withdrawal Amount')}
        labelTextStyle={styles.lightText}
        labelHeight={32}
        tintColor={'rgb(74, 144, 226)'}
        baseColor={'rgb(74, 144, 226)'}
        activeLineWidth={1}
        prefix={I18n.currencySymbol()}
        affixTextStyle={styles.sectionText}
        onChangeText={this._onWithdrawalAmountChange}
        textColor={'rgb(74, 144, 226)'}
        fontSize={prefixFontSize}
        onFocus={this._onInputFocus}
        onBlur={this._onInputBlur}
        value={this.state.withdrawalAmount}
        errorColor={'rgb(188, 33, 49)'}
        error={error}
        accessible={true}
        accessibilityLabel={accessibilityLabel}
      />
    );
  }

  _renderProcessingFee(): React.ReactNode {
    return (
      <View style={[styles.detailRow, {marginTop: 8}]}>
        <Label style={[styles.lightText, styles.flexOne]} testID={TEST_IDS.processing_fee}>
          {I18n.message('Processing Fee')}
        </Label>
        <TouchableOpacity
          style={styles.infoButton}
          onPress={this._showStaticModalProcessingFee}
          accessible={true}
          accessibilityLabel={'processing_fee_info'}
          hitSlop={{top: 10, left: 10, bottom: 10, right: 10}}
        >
          <SkillzImage
            source={'ic_info_skz.png'}
            color={'rgb(74, 144, 226)'}
            style={styles.infoIcon}
          />
        </TouchableOpacity>
        <Label style={styles.sectionText} testID={TEST_IDS.processing_fee_amount}>
          {this._formatToCurrency(this._processingFee)}
        </Label>
      </View>
    );
  }

  _renderContent(): React.ReactNode {
    const behavior = Sizes.isPortrait() ? 'position' : undefined;
    const verticalOffset = Platform.OS == 'ios' ? 44 : 0;
    const isCancellationEnabled =
      ClientPropertyConstants.getPlayerWithdrawalCancellationAllEnabled();

    return (
      <View style={styles.container}>
        {this._renderPayPalLimitBanner()}
        <View style={styles.container}>
          <KeyboardAvoidingView
            style={styles.container}
            contentContainerStyle={styles.container}
            behavior={behavior}
            keyboardVerticalOffset={verticalOffset}
          >
            <ScrollView
              style={styles.container}
              contentContainerStyle={styles.contentContainer}
              ref={(ref: unknown) => {
                this._scrollView = ref as ScrollView | null;
              }}
              onContentSizeChange={this._onContentSizeChange}
              onLayout={this._onContentLayout}
              testID={TEST_IDS.withdraw_screen}
            >
              {isCancellationEnabled && (
                <CancelWithdrawal
                  containerStyleOverride={styles.cancelWithdrawalContainer}
                  position='top'
                />
              )}
              {CurrencyController.isUSD() && this._renderMethodSection()}
              {this._renderPaypalEmailSection()}
              {this._renderAddressSection()}
              {this._renderWithdrawalDetails()}
              {this._renderFAQSupportSection()}
              <Optional test={Sizes.isLandscape() && Sizes.isPhone()}>
                {this._renderFooter()}
              </Optional>
            </ScrollView>
          </KeyboardAvoidingView>
        </View>
      </View>
    );
  }

  _renderFooter(): React.ReactNode {
    return (
      <View style={styles.footer}>
        <PushButton
          style={styles.nextButton}
          onPress={this._onNextPress}
          colors={['rgb(74, 144, 226)']}
          title={I18n.message('Next')}
          textStyle={styles.nextButtonText}
          cornerRadius={4}
          enabled={!this._isBlockedByPayPalLimit()}
        />
      </View>
    );
  }

  _renderPhone(): React.ReactNode {
    return (
      <View style={styles.container}>
        {this._renderNavigationBar()}
        <View style={[styles.container, {marginTop: IOS_NAV_BAR_HEIGHT}]}>
          {this._renderContent()}
          {this._renderFooter()}
        </View>
      </View>
    );
  }

  _renderPhoneLandscape(): React.ReactNode {
    return (
      <View style={styles.landscapeAndTabletBG}>
        {this._renderNavigationBar()}
        <View style={styles.landscapePhoneContainer}>{this._renderContent()}</View>
      </View>
    );
  }

  _renderTablet(): React.ReactNode {
    return (
      <View style={styles.landscapeAndTabletBG}>
        {this._renderNavigationBar()}
        <View style={styles.tabletContainer}>
          {this._renderContent()}
          {this._renderFooter()}
        </View>
      </View>
    );
  }

  render(): React.ReactNode {
    return Sizes.select({
      tablet: this._renderTablet(),
      phoneLandscape: this._renderPhoneLandscape(),
      other: this._renderPhone(),
    });
  }
}
